export default __webpack_public_path__ + "static/media/bg-cta.50701bd1.jpg";